export default __webpack_public_path__ + "static/media/0.6c7335fb.png";